export default "__VITE_ASSET__DQceR6DO__"